/*
 * © 2020 Microsoft. All rights reserved.
 */

define('Solitaire/Solitaire',['lodash',
    'absolute/debug',
    'absolute/storagemanager',
    'util/eventhandler',
    'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
    'Arkadium/GameEngine/Core/EngineManagers',
    'Arkadium/GameEngine/Tween/Tween',
    'Solitaire/SolitaireGameMode',
    'Solitaire/HintsOption',
    'Solitaire/TipsOption',
    'Solitaire/ScoringOption',
    'Solitaire/GameState',
    'Solitaire/GameResult',
    'Solitaire/GameModes/IGameMode',
    'Solitaire/GameModes/GameModeFactory',
    'Solitaire/GameModes/UnknownGameMode',
    'CardUI/SupplyView',
    'SolitaireShared/CardLogic/Supply',
    'SolitaireShared/CardLogic/CardAction',
    'absolute/eventbus',
    'util/SettingsManager',
    'util/ThemeManager',
    'Solitaire/SolitaireStatistics',
    'absolute/spriteutils',
    'Solitaire/GameContainer',
    'Managers/AdManager',
    'Managers/TelemetryManager',
    'absolute/musicmanager',
    'absolute/audiomanager',
    'MenuUI/TimesUpDialog',
    'absolute'
],
    function (_,
        Debug,
        StorageManager,
        EventHandler,
        SpriteNode,
        EngineManagers,
        Tween,
        SolitaireGameMode,
        HintsOption,
        TipsOption,
        ScoringOption,
        GameState,
        GameResult,
        IGameMode,
        GameModeFactory,
        UnknownGameMode,
        SupplyView,
        Supply,
        CardAction,
        EventBus,
        SettingsManager,
        ThemeManager,
        SolitaireStatistics,
        SpriteUtils,
        GameContainer,
        AdManager,
        TelemetryManager,
        MusicManager,
        AudioManager,
        TimesUpDialog,
        Absolute
    ) {
        "use strict";

        var SolitaireGame = function (ui, game) {
            this.initSolitaireGame(ui, game);
        };

        SolitaireGame.prototype = Object.create(SpriteNode.prototype);
        SolitaireGame.prototype.constructor = SolitaireGame;

        /*    SolitaireGame.MusicOptionKey = "APPDATA_MUSIC";
            SolitaireGame.SoundOptionKey = "APPDATA_SOUND";
            SolitaireGame.HintsOptionKey = "APPDATA_HINTS";
            SolitaireGame.TipsOptionKey = "APPDATA_TIPS";
            SolitaireGame.ThemeOptionKey = "APPDATA_THEME";
            SolitaireGame.WinAnimationOptionKey = "APPDATA_ANIMATION";*/
        SolitaireGame.HINT_TIME_DELAY_MS = 30000;
        SolitaireGame.HINT_TIME_DELAY_MS_DC = 1;

        /*SolitaireGame.DefaultSoundOption = 1.0;
        SolitaireGame.DefaultMusicOption  = 1.0;
        SolitaireGame.DefaultHintsOption = HintsOption.Enable;
        SolitaireGame.DefaultTipsOption = TipsOption.Enable;

        SolitaireGame.DefaultOnOfGameEndAnimations = true;
        SolitaireGame.DefaultOnOffBackgroundAnimations = true;*/

        SolitaireGame.ReadyForNavigation = true;

        SolitaireGame.prototype.initSolitaireGame = function (ui, game) {
            SpriteNode.call(this);
            this.game = game;
            this.ui = ui;

            /**
             * Private
             */
            this._previousHint = null;
            this._hintTimeElapsed = 0;
            this._gameContainer = null;
            this._gameBackground = null;
            this._coveringSprite = null;
            this._isBackgroundRightPressed = false;
            this.settingsManager = SettingsManager;

            /**
             * Public
             */

            this.AnimationsEnabled = new EventHandler();

            this.NeedUpdateNews = false;

            this.KeyboardStatus = new SolitaireGame.KeyboardEnabled();

            this.IsTipShowing = false;

            this._activeMode = SolitaireGameMode.Unknown;

            this.CurrentChallenge = null;

            this._activeHelpMode = null;

            this.TimerStatus = null;

            this.OutOfTime = false;
            this.LockFue = false;

            this.SentientManager = null;

            this.Authority = null;
            this.SupplyView = null;

            this.Template = null;

            this._soundOption = this.settingsManager.getSetting('general', 'soundFx');//SolitaireGame.DefaultSoundOption;
            this._musicOption = this.settingsManager.getSetting('general', 'music');//SolitaireGame.DefaultMusicOption;
            this._hintsOption = this.settingsManager.getSetting('general', 'hints');//SolitaireGame.DefaultHintsOption;

            this._onOfGameEndAnimations = this.settingsManager.getSetting('general', 'gameEndAnimation');// SolitaireGame.DefaultOnOfGameEndAnimations;
            //this._onOffBackgroundAnimations = SolitaireGame.DefaultOnOffBackgroundAnimations;

            this.NextWinAnimation = 0;

            this.TipsOption = SolitaireGame.DefaultTipsOption;

            this.GameResult = null;

            this._gameSetupComplete = false;

            this.SetupComplete = new EventHandler();

            this.ForceStartFUE = false;

            this.IsFueOpened = false;

            this.ExternalSettings = null;


            this.OnMoveCards = new EventHandler();

            this.NextWinAnimation = 0;
            this.ExternalSettings = null;// TODO new SolitaireExternalSettings();
            this.OptInManager = null; // TODO new SolitaireOptInLogic();
            this.TimerStatus = new SolitaireGame.TimerEnabled();
            this.GameStarted = false;
            //Windows.UI.Core.CoreWindow.GetForCurrentThread().VisibilityChanged += OnVisibilityChanged;

            // TODO
            //this.Updated += EngineFrame;
            //App.CurrentApp.Suspending += CurrentAppSuspending;
            //Resuming += OnGameResuming;
            //Exiting += OnGameExiting;

            // TODO
            //SolitaireAchievements.Instance.Initialize();

            //GameNetClient.Default.InternetConnected += DefaultInternetConnected;

            this._gameStartLock = {};
            this._gameStarting = false;
            this.CorruptLoad = false;

            /***
             * CBR TODO TMP
             */
            this.PointMove = new EventHandler();
            this.PointUp = new EventHandler();

            this.mouseup = function (event) {
                // fix an issue on iOS devices in desktop mode
                if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
                    return;
                }
                this.PointUp.handleEvent(this, event);
            }.bind(this);

            this.mousemove = function (event) {
                // fix an issue on iOS devices in desktop mode
                if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
                    return;
                }
                this.PointMove.handleEvent(this, event);
            }.bind(this);

            this.touchend = function (event) {
                this.PointUp.handleEvent(this, event);
            }.bind(this);

            this.touchmove = function (event) {
                this.PointMove.handleEvent(this, event);
            }.bind(this);

            this.interactive = true;

            this.Register(this);
            EngineManagers.Init(this.game, this.ui);
            EngineManagers.Sounds.UpdateSoundState(this._soundOption, this._musicOption);

            GameState.CurrentGame = this;

            this.AutoSave();
        };

        // TODO tmp
        Object.defineProperty(SolitaireGame.prototype, "Root", {
            get: function () {
                return this;
            }
        });


        SolitaireGame.prototype.OnAnimationsEnabled = function (e) {
            if (this.AnimationsEnabled) {
                this.AnimationsEnabled.handleEvent(this, e);
            }
        };

        SolitaireGame.KeyboardEnabled = function () {
            this.initKeyboardEnabled();
        };

        SolitaireGame.KeyboardEnabled.prototype.initKeyboardEnabled = function () {
            this.Enabled = true;
        };

        SolitaireGame.Current = null;

        Object.defineProperty(SolitaireGame.prototype, "ActiveMode", {
            get: function () {
                if (this._activeMode == null) {
                    return new UnknownGameMode();
                }
                return this._activeMode;
            },
            set: function (value) {
                if (this._activeMode == null) {
                    this._activeMode = GameModeFactory.InitGameMode(SolitaireGameMode.Unknown);
                }
                this._activeMode = value;
            }
        });


        Object.defineProperty(SolitaireGame.prototype, "ActiveHelpMode",
            {
                get: function () {
                    if (this._activeMode != null && this._activeMode.Name != SolitaireGameMode.Unknown) {
                        return this._activeMode;
                    }

                    if (this._activeHelpMode == null) {
                        return new UnknownGameMode();
                    }
                    return this._activeHelpMode;
                },
                set: function (value) {
                    if (this._activeHelpMode == null) {
                        this._activeHelpMode = GameModeFactory.InitGameMode(SolitaireGameMode.Unknown);
                    }
                    this._activeHelpMode = value;
                }
            });


        SolitaireGame.TimerEnabled = function () {
            this.initTimerEnabled();
        };

        SolitaireGame.TimerEnabled.prototype.initTimerEnabled = function () {
            this.DisabledForWindowVisibility = false;
            this.DisabledForShowingDialog = false;
            this.DisabledForSolving = false;
            this.DisabledForPortrait = false;
        };

        SolitaireGame.prototype.updateSetting = function (setting, value) {

            switch (setting) {
                case 'soundFx':
                    EngineManagers.Sounds.UpdateSoundState(value, -1);
                    break;
                case 'music':
                    EngineManagers.Sounds.UpdateSoundState(-1, value);
                    break;
                case 'layoutDirection':
                    this.Template.DoLayoutPiles(this.RenderManager, this.SupplyView);
                    if (this.Authority.CardSupply.GameName === 'Pyramid') {
                        this.game.gameScreenUI.drawButton.rotateIcon();
                    }
                    if (this.Authority.CardSupply.GameName === 'TriPeaks') {                        
                        this.game.gameScreenUI.updateLayout();
                    }
                    break;
                case 'cardsPerDraw':
                    break;
                case 'scoringType':
                    break;
                case 'suits':
                    break;
                case 'timer':
                    break;
                case 'hints':
                    break;
                case 'showAlerts':
                    break;
                case 'gameEndAnimation':
                    break;
                case 'singleTapToMove':
                    break;
            }

        };

        Object.defineProperty(SolitaireGame.TimerEnabled.prototype, "Enabled", {
            get: function () {
                return !this.DisabledForWindowVisibility && !this.DisabledForShowingDialog && !this.DisabledForSolving && !this.DisabledForPortrait;
            }
        });


        Object.defineProperty(SolitaireGame.prototype, "SoundOption",
            {
                get: function () {
                    return this._soundOption;
                },
                set: function (value) {
                    if (this._soundOption == value) {
                        return;
                    }
                    this._soundOption = value;
                    //SoundConfigurator.SetSound(value);
                    // TODO mute?
                }
            });

        Object.defineProperty(SolitaireGame.prototype, "MusicOption",
            {
                get: function () {
                    return this._musicOption;
                },
                set: function (value) {
                    if (this._musicOption == value) {
                        return;
                    }
                    this._musicOption = value;
                    // SoundConfigurator.SetMusic(value);
                    // TODO mute?
                }
            });


        Object.defineProperty(SolitaireGame.prototype, "HintsOption", {
            get: function () {
                return this.settingsManager.getSetting('general', 'hints');
            },
            set: function (value) {
                this._hintsOption = value;
                if (
                    SolitaireGame.Current.SupplyView != null &&
                    this._hintsOption == HintsOption.Disable &&
                    (SolitaireGame.Current.Authority != null && !SolitaireGame.Current.Authority.IsChallenge)
                )
                    SolitaireGame.Current.SupplyView.ClearHints();
            }
        });

        Object.defineProperty(SolitaireGame.prototype, "OnOfGameEndAnimations",
            {
                get: function () {
                    return this.settingsManager.getSetting('general', 'gameEndAnimation');
                },
                set: function (value) {
                    this._onOfGameEndAnimations = value;
                    // TODO
                    //DailyChallengeService.Default.Setup.IsAnimationsEnabled = value;
                    //PuzzleModeService.Default.DataSource.IsAnimationEnabled = value;
                }
            });


        /*Object.defineProperty(SolitaireGame.prototype, "OnOffBackgroundAnimations",
        {
            get: function () { return this._onOffBackgroundAnimations; },
            set: function (value)
            {
                this._onOffBackgroundAnimations = value;
                if(this._gameBackground != null)
                {
                    this._gameBackground.AnimationsEnabled = value;

                    this.OrganizeBackgroundRtt();
                    this.OnAnimationsEnabled(value);
                }
            }
        });*/

        Object.defineProperty(SolitaireGame.prototype, "DrawOption",
            {
                get: function () {
                    return parseInt(this.Authority.CardSupply.GetOption("Draw"));
                }
            });

        Object.defineProperty(SolitaireGame.prototype, "ScoringOption",
            {
                get: function () {
                    try {
                        return this.Authority.CardSupply.GetOption("Scoring");
                    } catch (Exception) {
                        return ScoringOption.Standard;
                    }
                }
            });

        Object.defineProperty(SolitaireGame.prototype, "SuitsOption",
            {
                get: function () {
                    return parseInt(this.Authority.CardSupply.GetOption("Suits"));
                }
            });

        /*Object.defineProperty(SolitaireGame.prototype, "GameState",
        {
            get: function () { return GameState.Current; },
            set: function (value) { GameState.Current = value; }
        });*/

        Object.defineProperty(SolitaireGame.prototype, "GameSetupComplete",
            {
                get: function () {
                    return this._gameSetupComplete;
                },
                set: function (value) {
                    if (this._gameSetupComplete == value) {
                        return;
                    }
                    this._gameSetupComplete = value;
                    if (value) {
                        this.SetupComplete.handleEvent(this);
                    }
                }
            });

        SolitaireGame.prototype.GetUserAvatar = function () {
            return ""; // unsupported;
            /*if (GameNetClient.Default.Settings.XblConnected && !string.IsNullOrEmpty(XboxLiveModel.Instance.AvatarImageUrl))
            {
                return XboxLiveModel.Instance.AvatarImageUrl;
            }
            return string.Empty;*/
        };


        SolitaireGame.prototype.OnCardsMoved = function () {
            var handler = this.OnMoveCards;
            if (handler != null) {
                handler.handleEvent();
            }

            if (this.Authority && !this.Authority.IsChallenge) {
                this._previousHint = null;
            }
        };




        SolitaireGame.prototype.ClearHintsCallback = function () {
            this._hintTimeElapsed = 0;
        };

        SolitaireGame.prototype.CurrentAppSuspending = function (sender, /* SuspendingEventArgs */ e) {
            // TODO
            /*
                if (App.CurrentApp.RootFrame.CurrentSourcePageType == typeof (MainPage))
                {
                    NewsModule.NewsModuleService.Instance.Suspending(true);
                }

                var df = e.SuspendingOperation.GetDeferral();

                var resetEvent = new ManualResetEvent(false);
                var tokenSource = new CancellationTokenSource();

                if (GameState != null)
                {
                    PerformSaveGame(resetEvent, tokenSource.Token);
                }

                resetEvent.WaitOne(500);
                //tokenSource.Cancel();

                df.Complete();*/
        };

        SolitaireGame.prototype.PerformSaveGame = function (/* ManualResetEvent @ */ event, /* CancellationToken */ cancellationToken) {
            setTimeout(function () {

                this.SaveGame();
            }.bind(this), 0);
        };

        SolitaireGame.prototype.InitGame = function () {
            // TODO
            //this.SentientManager = new SentientManager(new SentientSettings());
            // AnalyticsHelper.Current.InitializeCommonEventTracking();

            //GameEngine.Particles.Mercury.ParticleEffect.SetBaseAssetPath(@"Particles\Textures");
            //AudioController.Default.CanPlay(CommonSounds.UiCollapsing);
            //SetupCameras();

            // TODO
            //DCSponsorThemesService.Default.ThemeEnablingChanged += Default_ThemeEnablingChanged;

            //#if ARM
            //            Arkadium.GameEngine.Scenes.Scene.DepthLatency = 10.0f;
            //#endif
        };
        /*
         private void SetupCameras()
         {
             ((RenderManager)RenderManager).Target.RenderPriority = uint.MaxValue;

             // Create the 3D scene camera
             var camera3D = new LookAtCamera(((RenderManager) RenderManager).Target, Vector3.Zero,
             CameraDimension.Dimension3D)
             {
                 Lens = new PerspectiveLens(EngineManagers.Display.Width, EngineManagers.Display.Height, 1, 100,
                     (float) Math.PI/4.0f),
                 InputEnabled = true,
                     AttachedNode = Scene.Root
             };
             camera3D.SetPosition(0, 0, -5);
             camera3D.LookAt(0, 0, 0);

             // Create the 2D scene camera
             var camera2D = new Camera(((RenderManager)RenderManager).Target, CameraDimension.Dimension2D)
             {
                 Lens = new OrthographicLens(EngineManagers.Display.Width, EngineManagers.Display.Height, 0, 10),
                     InputEnabled = true,
                     AttachedNode = Scene.Root
             };
             camera2D.SetPosition(0, 0, 0);

             // Add the cameras to the scene
             Scene.AddCamera(SolitaireCameras.SolitaireMain3DCamera.ToString(), camera3D);
             Scene.AddCamera(SolitaireCameras.SolitaireMain2DCamera.ToString(), camera2D);
         }
         */

        SolitaireGame.prototype.EngineFrame = function (sender, eventArgs) {
            this.Update(EngineManagers.Time);
        };

        /* public async void */
        SolitaireGame.prototype.StartGame = function (game, newDeal, resetScoring, statLossRedeal, showAd) {
            newDeal = !!newDeal;
            resetScoring = !!resetScoring;

            // if we are already starting a game, punt.
            //lock (_gameStartLock)
            //{
            if (this._gameStarting) {
                return;
            }
            this._gameStarting = true;
            //}

            // TODO
            /*
            try
            {
                //App.CurrentApp.Engine.Scene.Root.Visible = false;
                // if we are still loading assets, wait.
                if (!this._resourcesLoaded || ThemeManager.LoadedTheme == null)
                {
                    await Task.Run(() =>
                {
                    var ev1 = new ManualResetEvent(false);
                    while (!_resourcesLoaded || !_localizedResourcesLoaded || ThemeManager.LoadedTheme == null)
                    {
                        // wait a quarter second before trying again
                        ev1.WaitOne(30);
                    }
                });
            }
            */

            //await WaitForGameStop();

            if (this.ActiveMode != null && this.ActiveMode.Name == game) {
                return; // don't start the same mode twice
            }

            //Make sure that game stopped before start
            if (this.ActiveMode != null && this.ActiveMode.Name != SolitaireGameMode.Unknown) {
                /*await */
                this.StopGame(true);
            }

            this.GameResult = GameResult.None;

            this.ActiveMode = GameModeFactory.InitGameMode(game);

            this.Template = this.ActiveMode.CreateTemplate();

            if (this.Authority != null) {
                // TODO this.Authority.CardSupply.OnDealEvent -= CardSupply_OnDealEvent;
            }

            this.Authority = this.Template.CreateAuthority(this.CurrentChallenge);

            if (!this.Authority.IsChallenge) {

                this.Template.LoadGameOptions(this.Authority.CardSupply, resetScoring);
            }


            // TODO - what does this do?
            //App.CurrentApp.GameNetClient.GamePlayManager.Init(ActiveMode.Name.ToString());

            //Messenger.Default.Register<GamePlayLoadMessage>(this, PprCallback);
            //Messenger.Default.Register<GamePlayChosenLoadMessage>(this, LoadGameMessage);

            // this was overriding DC/SC timer settings
            this.Authority.CardSupply.IsTimerCountdown = (this.ActiveMode.TimerOption == IGameMode.TimerSettings.CountDown);

            /* await */
            this.Authority.CardSupply.IsWaitingForAds = true;
            this.game.gameScreenUI.isSavedGame = !newDeal;
            var loaded = this.LoadGame(newDeal);

            if (this.CorruptLoad && this.OnLoadCorruptFile != null) {
                this.OnLoadCorruptFile();
                this.CorruptLoad = false;
            }

            // check whether we should start as an "InProgress" game, if the user has done any moves yet.
            GameState.Current = this.Authority.CardSupply.HasMovedCards ? GameState.InProgress : GameState.BeforeGame;

            this.CreateViewRepresentation();
            //this.Authority.CardSupply.IsWaitingForAds = true;

            this.Authority.CardSupply.OnTimeRanOutEvent.add(this.CardSupply_OnTimeRanOut.bind(this));
            // TODO wire up event handlers
            this.SupplyView.OnMoveCardsEvent.add(this.SupplyView_OnMoveCards.bind(this));

            //Only capture if is saved game.
            //New games are captured in DealNewGame method
            if (!this.Authority.IsChallenge && loaded) {
                TelemetryManager.classicGameStart(
                    this.game.solitaire.Authority.CardSupply.GameName, 'Saved',
                    this.ScoringOption,
                    this.DrawOption,
                    this.SuitsOption,
                    this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY
                );
            }

            //if (!this.Authority.IsChallenge) {
            //    this.DealCardsAccordingToAds();
            //}
            (this.Authority.IsChallenge) ? this.SupplyView.doChallengeScaling() :
                this.SupplyView.doClassicScaling(!loaded, showAd);


            if (this._gameLoaded) {
                // TODO
                //AnalyticsHelper.Current.SendLevelContinue();
            }

            // TODO
            /*
            if (ThemeManager.LoadedTheme.MicroGoodTypeId != 0)
            {
                AnalyticsHelper.Current.SendConsumedMicroGood(ThemeManager.LoadedTheme.MicroGoodTypeId);
            }
            */

            this.GameStarted = true;


            if (this._coveringSprite != null) {
                this._coveringSprite.Alpha = 1;
            }
            //}
            //finally
            //{
            //lock (_gameStartLock)
            //{
            this._gameStarting = false;
            this.GameStarted = true;
            //}
            //}
        };

        SolitaireGame.prototype.Default_ThemeEnablingChanged = function (sender, e) {
            // TODO
            //ThemeManager.ReloadSponsorTheme();
        };

        SolitaireGame.prototype.DealCardsAccordingToAds = function () {
            if (this.Authority.IsChallenge) {
                this.AdsCompleted();
                //AdManager.tryShowAd(this.AdsCompleted.bind(this));
                // TODO
                // App.CurrentApp.SetInput(InputOption.Disable);
            } else {
                this.AdsCompleted();
                // TODO
                // App.CurrentApp.SetInput(InputOption.Enable);
            }
        };

        SolitaireGame.prototype.OnChallengeStarted = function () {
            // TODO
            //EngineManagers.Input.Enabled = true;
            this.AdsCompleted();
            // TODO
            // App.CurrentApp.SetInput(InputOption.Enable);
            this.TimerStatus.DisabledForShowingDialog = false;
        };

        SolitaireGame.prototype.AdsCompleted = function () {
            this.Authority.CardSupply.IsWaitingForAds = false;
            this.DealCards();

            // TODO
            //KeyboardProcessor.Default.Enable();
            if (this.SupplyView.HasRunInit) {
                this.SupplyView.ActivateInputAndNavigation();
            } else {
                this.SupplyView.AllowInitKeyboardOnLoad = true;
            }
        };

        SolitaireGame.prototype.DealCards = function () {
            if (!this._gameLoaded && this.Authority.CardSupply.IsGamePageLoaded && !this.Authority.CardSupply.CardsDealt) {
                this.Authority.Reset();
                this.Authority.CardSupply.CleanTemporaryOptions();
                this.Authority.CardSupply.DeckSeed = null;
                this.Authority.CardSupply.GenerateGameKey();
                this.Authority.Deal();
            }
            Debug.log("Solitaire: cards dealt");

            this.ReadyForNavigation = true;
        };

        SolitaireGame.prototype.GameLoadingCompleted = function () {
            if (this.Authority == null) {
                return;
            }

            this.Authority.CardSupply.IsGamePageLoaded = true;
            // TODO
            /*if (this.Authority instanceof PyramidAuthority || this.Authority instanceof TriPeaksAuthority)
            {
                this.Authority.WinSetAction = this.CheckForBeKingAchievement;
            }*/
            if (!this.Authority.CardSupply.IsWaitingForAds) {
                this.DealCards();
            }
        };

        /*
    private static System.WeakReference<GamePage> _solitaireXamlPage;

    public void SetSolitairePage(GamePage page)
    {
        if (_solitaireXamlPage == null)
        {
            _solitaireXamlPage = new System.WeakReference<GamePage>(page);
        }
        else
        {
            _solitaireXamlPage.SetTarget(page);
        }
    }

    public GamePage GetSolitairePage()
    {
        GamePage page;

        if (_solitaireXamlPage != null && _solitaireXamlPage.TryGetTarget(out page))
        {
            return page;
        }

        return null;
    }
    */

        SolitaireGame.prototype.GameBackgroundOnOnMouseUp = function (sender, pointEvent) {
            if (this.mouseDown && !this.SupplyView.IsCardDragging) {
                this.SupplyView.GameInputInterpreter.ClearHighlight();
            }
            //this.mouseUp = true;
            this.mouseDown = false;

            if (!this._isBackgroundRightPressed) {
                return;
            }
            this._isBackgroundRightPressed = false;
            //if (pointEvent.Point.RightPressed || pointEvent.Point.LeftPressed) return;

            // TODO
            /*
            GamePage page;
            if (_solitaireXamlPage != null && _solitaireXamlPage.TryGetTarget(out page))
            {
                page.SetAppBarsOpen(!SupplyView.GameInputInterpreter.IsClickedOnCard);
                SupplyView.GameInputInterpreter.IsClickedOnCard = false;
            }
            */

        };

        SolitaireGame.prototype.GameBackgroundOnOnMouseDown = function (sender, pointEvent) {
            this.mouseDown = true;
            // TODO
            /*
            _isBackgroundRightPressed = pointEvent.Point.RightPressed;
            GamePage page;
            if (_solitaireXamlPage != null && _solitaireXamlPage.TryGetTarget(out page))
            {
                if(page.BottomAppBar.IsOpen)
                {
                    _isBackgroundRightPressed = false;
                }
            }
            */
        };

        SolitaireGame.prototype.CardSupply_OnDealEvent = function (sender) {
            if (this.SupplyView != null) {
                this.SupplyView.IsCardDragging = false;
            }
        };

        SolitaireGame.prototype.FadeOutAndInGame = function (savedGame) {
            if (this._coveringSprite != null && this._coveringSprite.Alpha == 0) {
                Tween.Start(this._coveringSprite)
                    .Wait(0.1)
                    .Then()
                    .FadeTo(1, 0.2)
                    .Call(function () {
                        this.ReloadGame(savedGame);
                    }.bind(this))
                    .Call(function () {
                        this.FadeInGame(function (sender, target) {
                        }, function () {
                        });
                    }); // SolitaireAchievements.Instance.CheckForAchievement(SolitaireAchievements.SolitaireAchievement.JackOfAllTrades);  // see if we have started a game of every game type
            } else {
                this.ReloadGame(savedGame);
            }
        };

        SolitaireGame.prototype.FadeInGame = function (update, end) {
            if (this._coveringSprite != null) {
                var tween = Tween.Start(this._coveringSprite).Wait(0.1).Then().FadeTo(0, 0.2).Call(end);
                tween.Updated.add(update);
            }
        };

        SolitaireGame.prototype.PresentGame = function () {
            this.Scene.Root.Visible = true;
            if (this.SupplyView != null) {
                this.SupplyView.OnMoveCards();
            }
        };


        SolitaireGame.prototype.CardSupply_OnTimeRanOut = function (sender) {
            if (this.Authority.CardSupply.GameName === "Pyramid") {
                var dialog = new TimesUpDialog(this.ui.currentScreen);
                dialog.onClose.add(function () {
                    this.GameResult = GameResult.OutOfTime;
                    GameState.Current = GameState.GameComplete;
                }.bind(this));
            } else if (GameState.Current == GameState.InProgress) {
                this.GameResult = GameResult.OutOfTime;
                GameState.Current = GameState.GameComplete;
            }
        };

        SolitaireGame.CardSupply_OnActionRun = function (sender, args) {
            // TODO
            SolitaireStatistics.Current.UpdateGameAction(SolitaireGame.Current.ActiveMode.GetStatKey());
            //SolitaireAwardsHelper.UpdateAwardsAsync(SolitaireAwardsUpdateContextFlags.OnAction);
        };

        // TODO
        /*


public event EventHandler<EventArgs> OnGameStarted;

public bool GameStarted
{
    get { return _gameStarted; }
    set
    {
        if (_gameStarted == value)
        {
            return;
        }
        _gameStarted = value;
        if (_gameStarted)
        {
            OnGameStarted.SafeInvoke(this);
        }
    }
}

private bool _gameStarted;

public async Task WaitForGameStart()
{
    if (GameStarted)
    {
        return;
    }

    while (!GameStarted)
    {
        await Task.Delay(50);
    }
}

public event EventHandler<EventArgs> OnGameStopped;

public bool GameStopped
{
    get { return _gameStopped; }
    set
    {
        if (_gameStopped == value)
        {
            return;
        }
        _gameStopped = value;
        if (_gameStopped)
        {
            OnGameStopped.SafeInvoke(this);
        }
    }
}

private bool _gameStopped;
private bool _gameStopping;

public async Task WaitForGameStop()
{
    if (GameStopped || !_gameStopping)
    {
        return;
    }

    var resetEvent = new ManualResetEvent(false);
    EventHandler<EventArgs> onGameStopped = null;
    onGameStopped = (sender, args) =>
    {
        OnGameStopped -= onGameStopped;
        resetEvent.Set();
    };
    OnGameStopped += onGameStopped;
    if (_gameStopping && !GameStopped)
    {
        await Task.Run(() => resetEvent.WaitOne());
    }
}

public async Task StopGame()
{
    await StopGame(false);
}
         */
        SolitaireGame.prototype.StopGame = function (calledFromStartGame) {
            calledFromStartGame = !!calledFromStartGame;
            if ((this.Authority !== null) && (this.ActiveMode.Name === SolitaireGameMode.Klondike) &&
                (this.Authority.CardSupply.UseCumulativeScoring) && (GameState.Current !== GameState.BeforeGame)) {
                this.Authority.CardSupply.CumulativeScore -= 52;
                if (this.Template !== null) this.Template.SaveGameOptions(this.Authority.CardSupply);
            }
            // if we are trying to stop the game, but some other thread is already trying to start a new game, bail out.
            if (!calledFromStartGame) {
                //lock (_gameStartLock)
                //{
                if (this._gameStarting) {
                    return;
                }
                this._gameStopping = true;
                this.GameStopped = false;
                EventBus.removeEventListener('LogActionComplete', this.saveGameHandlerRef);
                if (this.Authority && typeof this.Authority.CardSupply.CardAnimator.onHide === 'function') {
                    this.Authority.CardSupply.CardAnimator.onHide();
                }
                //}
            }
            if (this.GameResult == GameResult.None && (this.Authority != null && !this.Authority.IsChallenge)) {
                // TODO
                // AnalyticsHelper.Current.SendLevelSave();
            }

            try {
                if (this.Authority != null && this.Authority.IsChallenge) {
                    // TODO
                    //await ThemeManager.UnsetChallengeTheme();
                }

                //Make sure that game isnt sopped already
                if (this.ActiveMode.Name != SolitaireGameMode.Unknown) {
                    // hide where the game was.
                    // TODO this.Scene.Root.Visible = false;

                    this.GameStarted = false;

                    // TODO
                    //EngineManagers.Input.KeyDown -= ResetOptInStatistic;
                    //EngineManagers.Display.SizeChanged -= WindowSizeChanged;

                    if (this.SupplyView != null) {


                        // TODO - remove supplyview event handlers
                        this.SupplyView.OnMoveCardsEvent.remove(this.SupplyView_OnMoveCards.bind(this));
                        /*
                         this.SupplyView.Loaded -= OnSupplyViewLoaded;
                         this.SupplyView.CardSupply.OnTimeRanOut -= CardSupply_OnTimeRanOut;
                         this.SupplyView.CardSupply.OnActionRun -= CardSupply_OnActionRun;
                         this.SupplyView.OnMoveCardsEvent -= SupplyView_OnMoveCards;
                         this.SupplyView.CardSupply.OnAnimationEnded -= CardSupplyAnimationEnded;
                         this.SupplyView.CardSupply.OnDealEvent -= CardSupply_OnDealEvent;
                         */
                        //await Task.Run(() =>  SaveGame() );
                        this.SaveGame();
                    }
                    GameState.Current = null;

                    this.DestroySupplyView();

                    if (this.Template != null) {
                        this.Template.Cleanup();
                    }

                    this.Template = null;
                    this.Authority = null;
                    this.ActiveMode = GameModeFactory.InitGameMode(SolitaireGameMode.Unknown);

                    // TODO
                    /*
                     Messenger.Default.Unregister<GamePlayLoadMessage>(this, PprCallback);
                     Messenger.Default.Unregister<GamePlayChosenLoadMessage>(this, LoadGameMessage);
                     Messenger.Default.Unregister<FueClosed>(this, OnCustomFueClosed);
                     Messenger.Default.Unregister(this);
                     */
                }
            } finally {
                this._gameStopping = false;
                this.GameStopped = true;
            }
        };


        SolitaireGame.prototype.AutoSolve = function () {
            this.Template.TryAutoSolve(this.SupplyView);
        };


        SolitaireGame.prototype.SaveSettings = function () {
            try {
                /*
                /!* App.CurrentApp.Settings["MusicOptionKey"] = MusicOption.ToString();
                 App.CurrentApp.Settings["SoundOptionKey"] = SoundOption.ToString();
                 App.CurrentApp.Settings["TipsOptionKey"] = TipsOption.ToString();
                 App.CurrentApp.Settings["HintsOptionKey"] = HintsOption.ToString();
                 App.CurrentApp.Settings["WinAnimationOptionKey"] = NextWinAnimation.ToString();
                 App.CurrentApp.Settings["OnOfGameEndAnimationsKey"] = OnOfGameEndAnimations.ToString();
                 App.CurrentApp.Settings["OnOffBackgroundAnimationsKey"] = OnOffBackgroundAnimations.ToString();
                 *!/
                var settings = {};
                settings["MusicOptionKey"] = this.MusicOption;
                settings["SoundOptionKey"] = this.SoundOption;
                settings["TipsOptionKey"] = this.TipsOption;
                settings["HintsOptionKey"] = this.HintsOption;
                settings["WinAnimationOptionKey"] = this.NextWinAnimation;
                settings["OnOfGameEndAnimationsKey"] = this.OnOfGameEndAnimations;
                settings["OnOffBackgroundAnimationsKey"] = this.OnOffBackgroundAnimations;

                // TODO
                /!* if(ThemeManager.SelectedTheme != null) {
                 App.CurrentApp.Settings["ThemeOptionKey"] = ThemeManager.SelectedTheme.Key;
                 }
                 *!/
                //await App.CurrentApp.GameNetClient.GameDataManager.SaveList(App.CurrentApp.Settings, "Solitaire", "GlobalSettings");

                StorageManager.store("GlobalSettings", settings.toJSON());
                */
                if (this.Template != null) {
                    this.Template.SaveGameOptions(this.Authority.CardSupply);
                }
            } catch (e) {
            }
        };

        /*




/// <summary>
/// Sets the global settings
/// </summary>
public async Task ApplySettings()
{
    float musicVolume;
    float soundVolume;
    var nextAnimation = 0;
    float.TryParse(App.CurrentApp.Settings["MusicOptionKey"], out musicVolume);
    float.TryParse(App.CurrentApp.Settings["SoundOptionKey"], out soundVolume);
    if (App.CurrentApp.Settings.ContainsKey("WinAnimationOptionKey"))
        int.TryParse(App.CurrentApp.Settings["WinAnimationOptionKey"], out nextAnimation);

    bool onOfGameEndAnimations;
    if (App.CurrentApp.Settings.ContainsKey("OnOfGameEndAnimationsKey"))
    {
        bool.TryParse(App.CurrentApp.Settings["OnOfGameEndAnimationsKey"], out onOfGameEndAnimations);
    }
    else onOfGameEndAnimations = DefaultOnOfGameEndAnimations;


    bool onOffBackgroundAnimations;
    if (App.CurrentApp.Settings.ContainsKey("OnOffBackgroundAnimationsKey"))
    {
        bool.TryParse(App.CurrentApp.Settings["OnOffBackgroundAnimationsKey"], out onOffBackgroundAnimations);
    }
    else onOffBackgroundAnimations = DefaultOnOffBackgroundAnimations;

    MusicOption = musicVolume;
    SoundOption = soundVolume;
    NextWinAnimation = nextAnimation;
    OnOfGameEndAnimations = onOfGameEndAnimations;
    OnOffBackgroundAnimations = onOffBackgroundAnimations;

    EngineManagers.Sounds.GlobalVolume = soundVolume;
    ISoundPlayer player = SimpleIoc.Default.GetInstance<IApplicationContext>().GetModule<MediaPlayerModule>().SoundPlayer;
    player.Volume = soundVolume;
    ApplySoundSettingsToModules(soundVolume);

    TipsOption = (TipsOption)Enum.Parse(typeof(TipsOption), App.CurrentApp.Settings["TipsOptionKey"]);
    HintsOption = (HintsOption)Enum.Parse(typeof(HintsOption), App.CurrentApp.Settings["HintsOptionKey"]);

    String option;
    String wantTheme = "classic";
    if (App.CurrentApp.Settings.TryGetValue("ThemeOptionKey", out option))
    {
        wantTheme = (option) ?? wantTheme;
        if (string.IsNullOrEmpty(wantTheme))
        {
            wantTheme = "classic";
        }
    }
    if (ThemeManager.LoadedThemeKey != wantTheme)
    {
        var theme = ThemeManager.GetPackagedTheme(wantTheme);
        if (theme == null)
        {
            await ThemeManager.RefreshAvailableThemes();
            theme = ThemeManager.GetTheme(wantTheme);
        }
        if(theme == null)
        {
            wantTheme = "classic";
            theme = ThemeManager.GetPackagedTheme(wantTheme);
        }
        await ThemeManager.SetTheme(theme);
    }
}

private void ApplySoundSettingsToModules(float volume)
{
    if (DailyChallengesModule.SoundPlayer != null)
    {
        DailyChallengesModule.SoundPlayer.Volume = volume;
    }

    if (PuzzleModeModule.SoundPlayer != null)
    {
        PuzzleModeModule.SoundPlayer.Volume = volume;
    }

    if (AwardModule.SoundPlayer != null)
    {
        AwardModule.SoundPlayer.Volume = volume;
    }

    if (LeaderboardModuleClass.SoundPlayer != null)
    {
        LeaderboardModuleClass.SoundPlayer.Volume = volume;
    }

    if (AchievementModuleClass.SoundPlayer != null)
    {
        AchievementModuleClass.SoundPlayer.Volume = volume;
    }

    if (MicrosoftStoreModule.SoundPlayer != null)
    {
        MicrosoftStoreModule.SoundPlayer.Volume = volume;
    }

    if (UpsellModuleClass.SoundPlayer != null)
    {
        UpsellModuleClass.SoundPlayer.Volume = volume;
    }
}

#endregion

public String LocalizedAssetPath
{
    get { return String.Format(@"Content\bin\Localized\localized_{0}.respack", LocalizationManager.CurrentLanguage); }
}

public ChallengeMode CurrentChallengeMode { get; set; }
private bool _resourcesLoaded;
private bool _localizedResourcesLoaded;

public async Task LoadResourcesForGame()
{
    if (_resourcesLoaded)
    {
        return;
    }
    var gameplayTcs = new TaskCompletionSource<bool>();
    var guiTCS = new TaskCompletionSource<bool>();
    EngineManagers.Resources.CreateResource(@"Content\bin\gameplay\gameplay.respack", "gameplay_respack", (s, rh) => gameplayTcs.SetResult(true));

    EngineManagers.Resources.CreateResource(@"Content\Gui\bin\gui\gui.respack", "gui_respack", (s, rh) =>
    {
        EngineManagers.Gui.LayoutManager.Load("gui:klondike_layout", new KlondikeCodeBehind());
        EngineManagers.Gui.LayoutManager.Load("gui:spider_layout", new SpiderCodeBehind());
        EngineManagers.Gui.LayoutManager.Load("gui:freecell_layout", new FreecellCodeBehind());
        EngineManagers.Gui.LayoutManager.Load("gui:pyramid_layout", new PyramidCodeBehind());
        EngineManagers.Gui.LayoutManager.Load("gui:tripeaks_layout", new TriPeaksCodeBehind());
        EngineManagers.Gui.LayoutManager.Load("gui:dc_layout", new DcCodeBenind());

        EngineManagers.Gui.TargetResolution = new Vector2(1920, 1080);
        EngineManagers.Gui.TextScaleCoefficient = 0.3f;
        guiTCS.SetResult(true);
    });

    await Task.WhenAll(new[] { gameplayTcs.Task, guiTCS.Task });
    _resourcesLoaded = true;
}

public void LoadResourcesForLocalization()
{
    EngineManagers.Resources.CreateResource(LocalizedAssetPath, (s, rh) => { _localizedResourcesLoaded = true; });
}
*/
        SolitaireGame.prototype.SaveGame = function () {
            if (!this.GameIsValid() || this.Authority.IsChallenge) {
                return;
            }

            if (GameState.Current && (GameState.Current._name == GameState.InProgress._name || GameState.Current._name == GameState.BeforeGame._name)) {
                var actionList = this.Authority.CardSupply.GetActionLog();
                StorageManager.store(this.ActiveMode.Name.toString(), actionList);
            }
        };

        SolitaireGame.prototype.DeleteSavedGame = function () {
            StorageManager.store(this.ActiveMode.Name.toString(), "");
        };

        SolitaireGame.prototype.GetOption = function (option) {
            return this.Authority.CardSupply.GetOption(option);
        };

        SolitaireGame.prototype.DealNewGame = function (seedOverride, showAd, isSkipAdCall) {

            if (!isSkipAdCall)
                AdManager.gameStarted();

            this.PointMove.clear();
            this.PointUp.clear();

            this.PointUp.add(this.GameBackgroundOnOnMouseUpHandler);

            const searchParams = new URLSearchParams(window.location.search);
            var mode = searchParams.get('game');
            var seed = 0;

            if (SolitaireGameMode[mode] >= 0) {
                seed = searchParams.get('seed');
                if (seed) {
                    seedOverride = seed;
                }
            }

            if (this.Authority != null) {
                if (!this.Authority.IsChallenge) {

                    TelemetryManager.classicGameStart(
                        this.game.solitaire.Authority.CardSupply.GameName, 
                        'New',
                        this.ScoringOption,
                        this.DrawOption,
                        this.SuitsOption,
                        this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY
                    );
                    this.Authority.ForceDealScript(null);
                }

                if (GameState.Current == GameState.InProgress) {
                    //MusicManager.stopMusic();
                    this.IncrementGameCount();
                }

                this.Authority.Reset();
                GameState.Current = GameState.BeforeGame;

                this.UpdateAuthorityTimer();
                // Reset pile layout (end animations sometimes move piles around).
                this.Template.DoLayoutPiles(this.RenderManager, this.SupplyView);

                if (this.Authority.CardSupply.UseCumulativeScoring && GameState.Current != GameState.BeforeGame) {
                    this.Authority.CardSupply.CumulativeScore = this.Authority.CardSupply.CumulativeScore - 52;
                }
                this.Template.SaveGameOptions(this.Authority.CardSupply);
                if (this.game.solitaire.CurrentChallenge && this.Authority.IsChallenge) {
                    this.game.solitaire.CurrentChallenge.SetupOptionsForAuthority(this.Authority);
                } else {
                    this.Template.LoadGameOptions(this.Authority.CardSupply);
                }


                this.Authority.CardSupply.CleanTemporaryOptions();
                this.Authority.CardSupply.DeckSeed = seedOverride || null;
                if (this.Authority.CardSupply.CardAnimator != null) {
                    this.Authority.CardSupply.CardAnimator.DelayNextAnimation(.25);
                }
                this.Authority.CardSupply.GenerateGameKey();
                this.Authority.Deal(seedOverride);
                if (this.Authority.CardSupply.GameName === 'FreeCell') {
                    if (seed) {
                        this.settingsManager.setSetting('freecell', 'gameNumber', seedOverride);
                    }
                    else {
                        this.settingsManager.setSetting('freecell', 'gameNumber', this.Authority.CardSupply.DeckSeed);
                    }
                }
                this.OnCardsMoved();

                _.forEach(this.SupplyView.children, function (node) {
                    //if (node instanceof PileView)
                    //{
                    node.IsHinted = false;
                    //}
                });

                this.SupplyView.GameInputInterpreter.ClearHighlight();

                // this was overriding DC/SC timer settings
                this.Authority.CardSupply.IsTimerCountdown = (this.ActiveMode.TimerOption == IGameMode.TimerSettings.CountDown);

                // TODO
                /*if (Authority instanceof PyramidAuthority || Authority instanceof TriPeaksAuthority)
                {
                    Authority.WinSetAction = CheckForBeKingAchievement;
                }*/

                // TODO this.ProcessOptInAds();

                //this.GameState = GameState.BeforeGame;
                GameState.Current = GameState.BeforeGame;
                // TODO supported? RateGame.IncrementGamesPlayed();

                // TODO this.UpdateLayout();
                this.game.gameScreenUI.isSavedGame = false;
                this.game.gameScreenUI.onShow(
                    this.game.solitaire.Authority.CardSupply.Score,
                    this.game.solitaire.Authority.CardSupply.CurrentTime,
                    this.game.solitaire.Authority.BoardsCompleted(),
                    showAd
                );
            }
            //MusicManager.playMusic('music_theme_' + ThemeManager.CurrentTheme);
        };

        SolitaireGame.prototype.Reset = function () {
            this.Authority.Reset();
            this.Authority.Deal();
            this.Authority.CardSupply.StartGame();
            GameState.Current = GameState.BeforeGame;
        };

        SolitaireGame.prototype.Undo = function (isUndoBoard) {
            if (this.Authority.CardSupply.WaitingForAnimation) {
                return;
            }
            if (this.SupplyView.IsCardDragging) {
                return;
            }
            if (GameState.Current == GameState.AfterGame) {
                return;
            }
            //if (Authority.IsDailyChallenge)
            //return;

            if (!this.Authority.IsChallenge) {
                this.SupplyView.ClearHints();
            }
            this.SupplyView.ClearRevealCardStates();
            var undo = CardAction.sParse(this.Authority.CardSupply, ["undo", !isUndoBoard ? "1" : "-1"]);
            if (undo.Run()) {
                if (GameState.Current == GameState.GameComplete) {
                    GameState.Current = GameState.InProgress;
                }

                this.SupplyView.GameInputInterpreter.ClearHighlight();

                EngineManagers.Sounds.PlaySound("undo");
                this.SupplyView.OnMoveCards();
            }
        };

        SolitaireGame.prototype.Hint = function (shouldAbortSound) {
            if (this.Authority == null || (this.ActiveMode.WaitForAnimationOnHint && this.Authority.CardSupply.WaitingForAnimation)) {
                return;
            }

            if (GameState.Current != GameState.BeforeGame && GameState.Current != GameState.InProgress) {
                return; // no hints if the game has ended
            }
            if (!shouldAbortSound && !this.Authority.IsChallenge) AudioManager.playSound('hint');
            var hint = this.Authority.GetHint(true);
            if (!(hint.Equals(this._previousHint))) {
                this.SupplyView.ClearHints();
                this.SupplyView.DisplayHint(hint);
                this._previousHint = hint;
            }
        };

        SolitaireGame.prototype.Update = function (gameTime) {
            this.updateUndoButtons(!this.Authority.CardSupply.CanUndoActions());
            if (!this.GameIsValid()) {
                return;
            }
            GameState.UpdateCurrent();
            if (GameState.Current == GameState.BeforeGame || GameState.Current == GameState.InProgress) {
                if (this.SupplyView != null) {
                    this.SupplyView.KeyboardEnabled = this.KeyboardStatus.Enabled;
                }
            } else {
                if (this.SupplyView != null) {
                    this.SupplyView.KeyboardEnabled = false; // if the game is over, the keyboard is disabled no matter what
                }
            }

            if (this.TimerStatus.Enabled && GameState.Current == GameState.InProgress) {
                this.UpdateAuthorityTimer(gameTime);
            }

            this._hintTimeElapsed += gameTime.ElapsedGameTime.Milliseconds;
            if (this.HintsOption == HintsOption.Enable && !this.IsFueOpened) {
                var delay = this.Authority.IsChallenge ? SolitaireGame.HINT_TIME_DELAY_MS_DC : SolitaireGame.HINT_TIME_DELAY_MS;
                /*#if CHEATS
                        if (!(Authority is IPlayCardDailyAuthority || Authority is IPlayValuesDailyAuthority))
                        delay = HINT_TIME_DELAY_MS;
                #endif*/
                if (this._hintTimeElapsed >= delay) {
                    this.Hint(true);
                    this._hintTimeElapsed = 0;
                }
            }

            // Update the in game ui (buttons etc)
            if (this.game && this.game.gameScreenUI) {
                this.game.gameScreenUI.update(GameState, this.Authority);
            }

            SpriteNode.prototype.Update.call(this, gameTime, this.SupplyView.GetPileView('Stock').height / 2);
        };

        SolitaireGame.prototype.GameIsValid = function () {
            return this.ActiveMode != null && this.ActiveMode.Name != SolitaireGameMode.Unknown;
        };

        SolitaireGame.prototype.updateUndoButtons = function (isUndoEnabled) {
            this.game.gameScreenUI.updateUndoButtonsState(isUndoEnabled);
        };

        /*
        internal void OnMoveCardButton()
        {
            if (GameState.Current == GameState.InProgress || GameState.Current == GameState.BeforeGame)
            {
                ActiveMode.OnMoveCardButton();
                ClearHintsAndTimer();
            }
        }
    
        internal void PlayThemeMainSound()
        {
            if (EngineManagers.Sounds.HasSound("theme_ambient") && (ThemeManager.LoadedTheme is PackagedSolitaireTheme))
            {
                EngineManagers.Sounds.PlaySound("theme_ambient");
            }
        }
    
        internal void StopThemeMainSound()
        {
            EngineManagers.Sounds.StopSound("theme_ambient");
        }
    
        #endregion
    
        #region Private methods
        */
        SolitaireGame.prototype.DestroySupplyView = function () {

            this.PointMove.clear();
            this.PointUp.clear();

            //EventBus.removeEventListener('LogActionComplete', this.saveGameHandlerRef);

            // TODO EngineManagers.Gui.NavigationController.FocusedControl = null;
            // TODO OptInManager.CloseOptInPopup();
            if (this.SupplyView != null) {
                // TODO RttHelper.UnregisterEvents();
                // TODO RttHelper.DisableRtt();
                //this.SupplyView.Destroy();
                //this.SupplyView.ClearHintsCallback = null;
                // TODO
                /*
                this.SupplyView.MouseUp -= GameBackgroundOnOnMouseUp;
                this.SupplyView.MouseDown -= GameBackgroundOnOnMouseDown;
                this.SupplyView.CardSupply.FlipCard -= OnFlipCard;
                this.SupplyView.CardSupply.FlipCard -= OnFlipCardCount;
                */

                //this.SupplyView.ClearKeyboardUIElements();

                // if we have any animations running, abort them immediately
                /*if (this.SupplyView.CardSupply.CardAnimator != null && this.SupplyView.CardSupply.CardAnimator.WinAnimator != null)
                {
                    this.SupplyView.CardSupply.CardAnimator.WinAnimator.EndAnimation();
                    this.SupplyView.CardSupply.CardAnimator.WinAnimator = null;
                }
                this.SupplyView.Navigatable = false;*/
                // TODO this.SupplyView.AutomaticMovesStart -= OnAutomaticMovesStart;
                // TODO this.SupplyView.AutomaticMovesStop -= OnAutomaticMovesStop;

                window.removeEventListener('keydown', this.SupplyView.pressKeyReference, true);
                SpriteUtils.destroyAllChildren(this.SupplyView);
                if (this._gameContainer) {
                    this._gameContainer.removeSupplyView();
                }


                this.SupplyView = null;
            }
            if (this._gameBackground != null) {
                //this._gameBackground.MouseUp.remove(this.GameBackgroundOnOnMouseUpHandler);
                this.PointUp.remove(this.GameBackgroundOnOnMouseUpHandler)
                this._gameBackground.MouseDown.remove(this.GameBackgroundOnOnMouseDownHandler);

                var bgChildren = this._gameBackground.children;
                for (var i = 0; i < bgChildren.length; i++) {
                    this._gameBackground.RemoveChild(bgChildren[i]);
                }

                /*if (this._gameBackground.Parent != null)
                {
                    this._gameBackground.Parent.RemoveChild(this._gameBackground);
                }*/

                this.Scene.Root.RemoveChild(this._gameBackground);

                this._gameBackground = null;
            }

            if (this._coveringSprite != null) {
                if (this._coveringSprite.Parent != null) {
                    this._coveringSprite.Parent.RemoveChild(this._coveringSprite);
                }

                this._coveringSprite = null;
            }

            this.DestroySceneNode(this._gameContainer);
            this._gameContainer = null;
        };

        SolitaireGame.prototype.DestroySceneNode = function (node) {
            if (node != null) {
                if (node.Parent != null && node.Parent.children.length > 0) {
                    node.Parent.RemoveChild(node);
                }
            }
        };

        SolitaireGame.prototype.IncrementGameCount = function () {
            SolitaireStatistics.Current.UpdateGameRedeal(this.ActiveMode.GetStatKey());
            //SolitaireAchievements.Instance.CheckForAchievement(SolitaireAchievements.SolitaireAchievement.JackOfAllTrades); // see if we have started a game of every game type
        };

        SolitaireGame.prototype.CheckForBeKingAchievement = function () {
            SolitaireStatistics.Current.UpdateBoardWonWithKing(this.ActiveMode.GetStatKey());
            //SolitaireAchievements.Instance.CheckForAchievement(SolitaireAchievements.SolitaireAchievement.GoodToBeKing); // see if we have started a game of every game type
        };

        /// <summary>
        /// Attempt to load a saved game (from the network or local -- temporarily just local). Returns true if the load succeeded, or false if there was no game.
        /// </summary>
        /// <returns></returns>
        SolitaireGame.prototype.LoadGame = function (skip) {
            this._gameLoaded = false;
            this.Authority.CardSupply.IsGamePageLoaded = false;
            if (this.Authority.IsChallenge || skip) {
                this.GameLoadingCompleted();
                return false;
            }
            Debug.log("..............................STARTING GAME -- LOADING GAME");
            //var savedGameLocal = await App.CurrentApp.GameNetClient.GamePlayManager.LoadAsync(this.ActiveMode.Name.ToString());
            var savedGame = StorageManager.fetch(this.ActiveMode.Name.toString()) || "foo";
            //var savedGame = "GAME SPIDER OPTION +GAMEID 123456789|WEB|+W DEAL 37086033901879989758245617919831807216623916707326389775667033341740694169369437944545264076276734163253350291736350241282160622382085502233335550539138046 B MOVE 18 30 1 MOVE 17 18 1 E B MOVE 30 16 2 MOVE 29 30 1 E B MOVE 20 26 1 MOVE 19 20 1 E B MOVE 2 12 1 MOVE 2 14 1 MOVE 2 16 1 MOVE 2 18 1 MOVE 2 20 1 MOVE 2 22 1 MOVE 2 24 1 MOVE 2 26 1 MOVE 2 28 1 MOVE 2 30 1 E MOVE 30 22 1 MOVE 22 14 1 MOVE 24 26 1 MOVE 12 24 1 B MOVE 12 26 1 MOVE 11 12 1 E B MOVE 12 24 1 MOVE 11 12 1 E B MOVE 12 26 1 MOVE 11 12 1 E MOVE 20 26 1 B MOVE 12 18 1 MOVE 11 12 1 E MOVE 24 18 1 MOVE 16 18 1 MOVE 16 18 1 B MOVE 12 18 1 MOVE 11 12 1 E MOVE 12 30 1 MOVE 18 12 6 B MOVE 18 14 1 MOVE 17 18 1 E B MOVE 18 24 1 MOVE 17 18 1 E B MOVE 18 30 1 MOVE 17 18 1 E B MOVE 18 26 1 MOVE 17 18 1 E MOVE 18 26 1 B MOVE 24 18 3 MOVE 23 24 1 E B MOVE 30 16 3 MOVE 29 30 1 E MOVE 14 16 3 B MOVE 2 12 1 MOVE 2 14 1 MOVE 2 16 1 MOVE 2 18 1 MOVE 2 20 1 MOVE 2 22 1 MOVE 2 24 1 MOVE 2 26 1 MOVE 2 28 1 MOVE 2 30 1 E MOVE 12 24 1 MOVE 26 24 8 B MOVE 26 28 2 MOVE 25 26 1 E B MOVE 26 30 1 MOVE 25 26 1 E B MOVE 26 28 1 MOVE 25 26 1 E MOVE 30 28 2 B MOVE 26 18 1 MOVE 25 26 1 E MOVE 18 14 2 MOVE 18 26 2 MOVE 24 26 9 MOVE 16 20 1 MOVE 20 16 2 B MOVE 20 26 1 MOVE 19 20 1 MOVE 26 3 -13 E B MOVE 20 24 1 MOVE 19 20 1 E MOVE 28 22 5 B MOVE 30 26 1 MOVE 29 30 1 E B MOVE 30 22 1 MOVE 29 30 1 E MOVE 30 24 1 MOVE 28 24 1 MOVE 28 22 1 MOVE 12 18 5 MOVE 16 18 6 B MOVE 22 18 1 MOVE 18 4 -13 E B MOVE 16 18 4 MOVE 15 16 1 E B MOVE 16 18 1 MOVE 15 16 1 E B MOVE 28 24 1 MOVE 27 28 1 E B MOVE 28 20 1 MOVE 27 28 1 E B MOVE 20 28 2 MOVE 19 20 1 E MOVE 22 28 7 MOVE 22 24 1 MOVE 20 22 1 B MOVE 28 20 10 MOVE 27 28 1 E MOVE 24 30 1 B MOVE 2 12 1 MOVE 2 14 1 MOVE 2 16 1 MOVE 2 18 1 MOVE 2 20 1 MOVE 2 22 1 MOVE 2 24 1 MOVE 2 26 1 MOVE 2 28 1 MOVE 2 30 1 E MOVE 30 20 1 MOVE 20 22 2 MOVE 22 18 3 MOVE 18 14 4 MOVE 30 18 1 MOVE 14 18 5 MOVE 28 20 1 B MOVE 20 12 11 MOVE 12 5 -13 E B MOVE 28 20 1 MOVE 27 28 1 E MOVE 14 12 3 MOVE 28 14 1 B MOVE 14 28 2 MOVE 13 14 1 E B MOVE 14 30 1 MOVE 13 14 1 E B MOVE 14 30 1 MOVE 13 14 1 E MOVE 20 14 1 B MOVE 14 20 2 MOVE 13 14 1 E MOVE 16 14 1 MOVE 28 20 1 B MOVE 16 24 1 MOVE 15 16 1 E B MOVE 16 22 1 MOVE 15 16 1 E B MOVE 16 24 1 MOVE 15 16 1 E MOVE 30 16 2 B MOVE 18 16 10 MOVE 16 6 -13 E B MOVE 22 16 3 MOVE 21 22 1 E B MOVE 22 28 1 MOVE 21 22 1 E B MOVE 22 26 1 MOVE 21 22 1 E B MOVE 22 18 1 MOVE 21 22 1 E MOVE 22 24 1 MOVE 24 22 4 MOVE 24 30 5 MOVE 16 22 3 B MOVE 24 16 1 MOVE 23 24 1 E MOVE 30 28 3 MOVE 20 24 3 B MOVE 24 20 4 MOVE 23 24 1 E B MOVE 24 12 1 MOVE 23 24 1 E MOVE 12 24 4 B MOVE 14 12 2 MOVE 13 14 1 E MOVE 14 26 1 MOVE 24 26 4 MOVE 26 28 5 MOVE 28 20 8 MOVE 26 14 1 B MOVE 2 12 1 MOVE 2 14 1 MOVE 2 16 1 MOVE 2 18 1 MOVE 2 20 1 MOVE 2 22 1 MOVE 2 24 1 MOVE 2 26 1 MOVE 2 28 1 MOVE 2 30 1 E MOVE 16 14 1 MOVE 20 28 1 B MOVE 26 20 1 MOVE 20 7 -13 E MOVE 28 20 2 MOVE 26 18 1 MOVE 18 20 4 MOVE 22 20 1 MOVE 22 20 5 B MOVE 24 20 1 MOVE 20 8 -13 E MOVE 14 18 2 MOVE 18 20 1 MOVE 14 16 1 MOVE 16 14 1 B MOVE 2 12 1 MOVE 2 14 1 MOVE 2 16 1 MOVE 2 18 1 MOVE 2 20 1 MOVE 2 22 1 MOVE 2 24 1 MOVE 2 26 1 MOVE 2 28 1 MOVE 2 30 1 E MOVE 20 22 1 MOVE 18 22 1 MOVE 20 18 1 MOVE 26 30 1 MOVE 30 22 2 MOVE 22 16 5 MOVE 16 22 6 MOVE 22 28 8 B MOVE 28 18 11 MOVE 18 9 -13 E MOVE 30 14 3 MOVE 14 26 4 MOVE 16 26 1 MOVE 14 26 1 MOVE 24 26 2 MOVE 12 14 1 MOVE 12 26 1 MOVE 12 26 2 N ";
            //var savedGame = "GAME KLONDIKE DEAL 69986293213090712343950876166007719079014988549809615311342241354238 B MOVE 15 4 1 MOVE 14 15 1 E B MOVE 11 19 1 MOVE 10 11 1 E B MOVE 15 11 1 MOVE 14 15 1 E MOVE 2 3 -3 B MOVE 19 15 2 MOVE 18 19 1 E B MOVE 19 15 1 MOVE 18 19 1 E MOVE 11 19 2 MOVE 2 3 -3 MOVE 3 5 1 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 9 1 B MOVE 21 9 1 MOVE 20 21 1 E MOVE 3 4 1 B MOVE 21 17 1 MOVE 20 21 1 E B MOVE 19 21 3 MOVE 18 19 1 E B MOVE 21 19 4 MOVE 20 21 1 E B MOVE 19 11 5 MOVE 18 19 1 E B MOVE 19 6 1 MOVE 18 19 1 E MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 2 -21 MOVE 2 3 -3 MOVE 3 21 1 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 21 1 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 2 -19 MOVE 2 3 -3 MOVE 3 13 1 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 11 1 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 11 1 B MOVE 15 11 4 MOVE 14 15 1 E MOVE 2 3 -3 MOVE 3 19 1 MOVE 3 15 1 B MOVE 21 15 3 MOVE 20 21 1 E B MOVE 21 7 1 MOVE 20 21 1 E MOVE 13 7 1 MOVE 2 3 -1 MOVE 3 2 -14 MOVE 2 3 -3 MOVE 3 17 1 MOVE 2 3 -3 MOVE 3 17 1 B MOVE 13 17 1 MOVE 12 13 1 E MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 15 1 MOVE 3 13 1 B MOVE 21 15 1 MOVE 20 21 1 E MOVE 21 15 1 MOVE 2 3 -2 MOVE 3 2 -10 MOVE 2 3 -3 MOVE 2 3 -3 MOVE 3 19 1 MOVE 3 13 1 MOVE 3 21 1 B MOVE 13 21 3 MOVE 12 13 1 E MOVE 13 21 1 MOVE 3 21 1 B MOVE 17 21 5 MOVE 16 17 1 E MOVE 3 17 1 MOVE 3 9 1 B MOVE 17 9 2 MOVE 16 17 1 E B MOVE 17 4 1 MOVE 16 17 1 E B MOVE 17 5 1 MOVE 16 17 1 E MOVE 17 6 1 MOVE 2 3 -3 MOVE 3 15 1 MOVE 3 15 1 MOVE 3 13 1 MOVE 2 3 -1 MOVE 3 6 1 MOVE 19 6 1 MOVE 21 5 1 MOVE 15 5 1 MOVE 15 6 1 MOVE 11 7 1 MOVE 21 7 1 MOVE 11 4 1 MOVE 21 4 1 MOVE 19 5 1 MOVE 15 5 1 MOVE 11 7 1 MOVE 19 7 1 MOVE 21 6 1 N ";
            Debug.log("..............................STARTING GAME -- GAME LOADED");
            //var savedGame = savedGameLocal.Result;

            // TODO Authority.CardSupply.LaunchType = AnalyticsHelper.Current.LaunchType;
            // TODO AnalyticsHelper.Current.LaunchType = Supply.SolitaireGameLaunchType.Home_Or_AppBar;
            var loadResult = false;
            if (savedGame) {
                //lock (_loadLock)
                //{
                loadResult = this._gameLoaded || this.LoadSavedGame(savedGame);
                //}
            } else // if (savedGameLocal.ErrorCode == (int)ErrorCode.UnknownException)
            {
                // TODO this.ShowCorruptedMessage();
                alert("Corrupted Saved Game");
            }
            return loadResult;
        };

        SolitaireGame.prototype.LoadSavedGame = function (savedGame) {
            try {
                this.Authority.CardSupply.CleanTemporaryOptions();
                this.Authority.CardSupply.DeckSeed = null;

                this.Authority.CardSupply.SuppressAnimations = true;
                // TODO
                if (savedGame != "foo") {
                    CardAction.RunActions(this.Authority.CardSupply, savedGame);
                } else {

                }

                this.Authority.CardSupply.SuppressAnimations = false;


                if (this.Authority.CardSupply.EnforceGameRules) {
                    this.OnCardsMoved();

                    this._gameLoaded = true;
                    return true;
                }
                this.GameLoadingCompleted();
            } catch (e) {
                this.CorruptLoad = true;
            }

            return false;
        };
        /*
        private void ShowCorruptedMessage()
        {
            var dialog = new MessageDialog(LocalizationManager.GetCommonLocalizedString("CorruptedFileMessage"));
            dialog.Commands.Clear();
            dialog.Commands.Add(new UICommand(LocalizationManager.GetCommonLocalizedString("CloseText"), null));
            dialog.CancelCommandIndex = 0;
            dialog.DefaultCommandIndex = 0;
    
            Messenger.Default.Send(dialog);
        }
    
        private void PprCallback(GamePlayLoadMessage msg)
        {
            if (msg.HasOnlineSave)
            {
                popupLock = true;
            }
        }
    
        private void LoadGameMessage(GamePlayChosenLoadMessage msg)
        {
            popupLock = false;
            if (Authority.IsChallenge || string.IsNullOrEmpty(msg.Value) || (msg.XblConnectionJustReceived && msg.Location == GamePlayDataLocation.Offline))
            {
                if (!msg.HadConflict)
                    Authority.CardSupply.ResetTime();
            }
            else if (!IsSaveSubset(msg.Value))
            {
                lock (_loadLock)
                {
                    FadeOutAndInGame(msg.Value);
                }
            }
        }
    
        private bool IsSaveSubset(string savedGame)
        {
            var currKey = Authority.CardSupply.GetGameKey();
            var msgKey = Supply.GetGameKey(savedGame);
            var actionList = Authority.CardSupply.GetActionLog();
    
            return msgKey == currKey && actionList.Length >= savedGame.Length;
        }
    
        private void ReloadGame(string savedGame)
        {
            GameState = GameState.InProgress;
            Authority.CardSupply.IsTimerCountdown = (ActiveMode.TimerOption == IGameMode.TimerSettings.CountDown);
            try
            {
                Authority.CardSupply.CleanTemporaryOptions();
    
                Authority.CardSupply.ResetGame();
                Authority.CardSupply.DeckSeed = null;
    
                Authority.CardSupply.SuppressAnimations = true;
                if (Authority is IBonusAuthority)
                {
                    var pAuth = (IBonusAuthority) Authority;
                    pAuth.SuppressBonusAnimations = true;
                }
                CardAction.RunActions(Authority.CardSupply, savedGame);
                Authority.CardSupply.SuppressAnimations = false;
                if (Authority is IBonusAuthority)
                {
                    var pAuth = (IBonusAuthority) Authority;
                    pAuth.SuppressBonusAnimations = false;
                }
    
                Template.SaveGameOptions(Authority.CardSupply);
    
                if (SupplyView != null)
                {
                    Template.DoLayoutPiles(RenderManager, SupplyView);
                }
    
                _gameLoaded = true;
            }
            catch (Exception)
            {
                CorruptLoad = true;
            }
    
            if (Authority.CardSupply.CardAnimator != null)
            {
                Authority.CardSupply.CardAnimator.DelayNextAnimation(.25f);
            }
    
            OnCardsMoved();
    
            if (SupplyView != null && SupplyView.Children != null)
            {
                foreach (ISceneNode node in SupplyView.Children)
                {
                    if (node is PileView)
                    {
                        (node as PileView).IsHinted = false;
                    }
                }
            }
    
            Messenger.Default.Send(new UISettingsChangedMessage());
            PresentGame();
        }
        */
        SolitaireGame.prototype.CreateViewRepresentation = function () {
            this.CreateSupplyView(this.Authority);
            this.Template.DoLayoutPiles(this.RenderManager, this.SupplyView);
        };
        /*
    
        private void WindowSizeChanged(object sender, EventArgs eventArgs)
        {
            UpdateLayout();
            if (SupplyView != null)
            {
                OrganizeRtt();
            }
        }
    
        private void UpdateLayout()
        {
            if (SupplyView != null && _gameBackground != null)
            {
                int width = EngineManagers.Display.Width;
                int height = EngineManagers.Display.Height;
                const float snapWidth = 320f;
                _gameBackground.Reposition(width, height);
                SetCorrectLayout();
                SetAspectRatio(SupplyView,
                        SupplyView.CurrentLayout == SupplyView.LayoutState.VerticalView ? snapWidth : width, height);
    
                Template.DoLayoutPiles(RenderManager, SupplyView);
            }
            UpdateCamerasViewportResize();
        }
    
        /// <summary>
        /// Allow to resize cameras viewport
        /// </summary>
        private void UpdateCamerasViewportResize()
        {
            Dictionary<string, Camera> cameras = Scene.GetCameras();
            foreach (KeyValuePair<string, Camera> pair in cameras)
            {
                pair.Value.Lens.ViewportWidth = EngineManagers.Display.Width;
                pair.Value.Lens.ViewportHeight = EngineManagers.Display.Height;
            }
        }
        */
        SolitaireGame.prototype.CreateSupplyView = function (gameAuthority) {


            this._gameContainer = new GameContainer(this.game);
            this.Scene.Root.AddChild(this._gameContainer);
            // TODO this._gameBackground = new ThemeBackgroundFactory().GetBackground();

            this._gameBackground = new SpriteNode(ThemeManager.CurrentTheme + "_bg/background.jpg");
            this._gameBackground.interactive = true;

            this._gameBackground.AnimationsEnabled = this.OnOffBackgroundAnimations;
            this._gameBackground.Layer = -5;

            this.GameBackgroundOnOnMouseUpHandler = this.GameBackgroundOnOnMouseUp.bind(this);
            //this._gameBackground.MouseUp.add(this.GameBackgroundOnOnMouseUpHandler);
            this.PointUp.add(this.GameBackgroundOnOnMouseUpHandler);
            this.GameBackgroundOnOnMouseDownHandler = this.GameBackgroundOnOnMouseDown.bind(this)
            this._gameBackground.MouseDown.add(this.GameBackgroundOnOnMouseDownHandler);
            this._gameBackground.X = EngineManagers.Display.Width * 0.5;
            this._gameBackground.Y = EngineManagers.Display.Height * 0.5;

            this._gameContainer.setBackground(this._gameBackground);

            this.SupplyView = new SupplyView(gameAuthority.CardSupply, EngineManagers.ui.width, EngineManagers.ui.height, this.game);
            if (!this.Authority.IsChallenge) {
                this.SupplyView.AllowInitKeyboardOnLoad = true;
            }

            // ARM optimizations - don't load certain images in certain game types.
            if (this.ActiveMode.Name == SolitaireGameMode.TriPeaks) {
                this.SupplyView.EnableHighlight = false;
            }
            //#if ARM
            SupplyView.EnableShadows = false;
            //#endif

            // TODO wire up supplyview events

            this.SupplyView.ClearHintsCallback = this.ClearHintsCallback.bind(this);
            /*
            this.SupplyView.AutomaticMovesStart += OnAutomaticMovesStart;
            this.SupplyView.AutomaticMovesStop += OnAutomaticMovesStop;
            this.SupplyView.MouseUp += GameBackgroundOnOnMouseUp;
            this.SupplyView.MouseDown += GameBackgroundOnOnMouseDown;
            */
            // register placeholder UI elements - the Xaml page will fill these in later!

            // TODO - Jarbot - UI control hooks
            /*
            RegisterUIElement("undo", null, null);
            RegisterUIElement("back", null, null);
            RegisterUIElement("drawcard", null, null);
            RegisterUIElement("dealnextdeck", null, null);
            */

            // TODO this.SetCorrectLayout();

            this.SupplyView.GetThemeAssetFunc = null; // TOOD ThemeManager.LoadedTheme.GetAssetPath;
            this.SupplyView.IsUserTheme = false; // not supported (ThemeManager.LoadedTheme is UserSolitaireTheme);
            // TODO this.SupplyView.LocalizedAssetPath = LocalizedAssetPath;

            this.SupplyView.GameInputInterpreter = this.Template.CreateInputInterpreter(this.Authority);

            this.SupplyView.Init(null);

            this.SupplyView.Register(this); // TODO CBR this is temp - need to find out how to set scene for supplyview

            //    this.SupplyView.X = EngineManagers.Display.Width*0.5;
            //   this.SupplyView.Y = EngineManagers.Display.Height*0.5;

            this.SupplyView.X = EngineManagers.Display.Width * 0.5;
            this.SupplyView.Y = EngineManagers.Display.Height * 0.5;


            this.Authority.CardSupply.CardAnimator = this.Template.CreateCardAnimator(this.SupplyView);

            // TODO this.SupplyView.Loaded += OnSupplyViewLoaded;
            this.SupplyView.GameContainer = this._gameContainer;

            this._gameContainer.setSupplyView(this.SupplyView);

            this.SupplyView.SetupPileViews();
            this.SupplyView.SetupCardViews();

            // TODO
            /*
            if (this._gameBackground != null)
                this._gameBackground.Reposition(EngineManagers.Display.Width, EngineManagers.Display.Height);
                */
            // TODO this.SetAspectRatio(SupplyView, EngineManagers.Display.Width, EngineManagers.Display.Height);

            if (this._coveringSprite == null) {
                this._coveringSprite = new SpriteNode();
                this._gameContainer.AddChild(this._coveringSprite);
            }
            this._coveringSprite.InputEnabled = false;
            this._coveringSprite.Layer = 10;
        };

        SolitaireGame.prototype.SupplyView_OnMoveCards = function (supply) {
            this._hintTimeElapsed = 0;
            this.OnCardsMoved();
        }


        SolitaireGame.prototype.AutoSave = function () {

            this.saveGameHandler = function () {
                this.SaveGame();
            }.bind(this);
            this.saveGameHandlerRef = this.saveGameHandler;

            EventBus.removeEventListener('LogActionComplete', this.saveGameHandlerRef);
            EventBus.addEventListener('LogActionComplete', this.saveGameHandlerRef);

        };


        SolitaireGame.prototype.UpdateAuthorityTimer = function (gameTime) {
            if (GameState.Current == GameState.InProgress && this.TimerStatus.Enabled && this._coveringSprite != null)// && this._coveringSprite.Alpha == 0)
            {
                this.Authority.CardSupply.AccumulateTime(gameTime.ElapsedGameTime.TotalMilliseconds / 1000.0);
            }
        };

        return SolitaireGame;

    });

